import { Suspense } from 'react';
import { Outlet, generatePath, useParams } from 'react-router';
import styled from 'styled-components';

import { Navigate } from '@sorare/routing';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useCurrentRoutePattern } from '@sorare/core/src/hooks/useCurrentRoutePattern';

import { ImportLineup } from '#src/components/importLineup/ImportLineup/index.tsx';
import { useLastVisitedPlayTab } from '#src/hooks/useLastVisitedPlayTab.ts';
import { getValidEventType } from '#src/lib/so5.ts';

const Relative = styled.div`
  position: relative;
  isolation: isolate;
`;

const PlayProLayout = () => {
  useLastVisitedPlayTab({ tab: 'play' });
  const { eventType, ...rest } = useParams();
  const validEventType = getValidEventType(eventType).toLowerCase();
  const currentRoutePattern = useCurrentRoutePattern();

  // Fallback for old routes
  if (eventType !== validEventType && currentRoutePattern) {
    return (
      <Navigate
        to={generatePath(`/${currentRoutePattern}`, {
          eventType: validEventType,
          ...rest,
        })}
        replace
        keepSearchParams
      />
    );
  }

  return (
    <Relative>
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
        <ImportLineup />
      </Suspense>
    </Relative>
  );
};

export default PlayProLayout;
